import {
  FullWidthHorizontalSeparator,
  PageTitle,
  PageWrapper,
} from "../../../../../../layout/portalPageLayout";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Tabs, TabPanels } from "@reach/tabs";
import { CustomTabPanel } from "../../../../../../components/ReachTabs/TabPanel";
import { TabList } from "../../../../../../components/ReachTabs/TabList";
import { Tab } from "../../../../../../components/ReachTabs/Tab";
import { AddExternalAssetFiles } from "./AddExternalAssetFiles";
import { UploadAssetsTab } from "./UploadAssetsTab";
import { useStoreState } from "../../../../../../util/util";

export const AssetBulkUploadHomePage = () => {
  const { t } = useTranslation();
  const {
    storefront_metadata: { enable_external_assets },
  } = useStoreState();
  const [currentTab, setCurrentTab] = useState<number>(0);

  return (
    <PageWrapper id="bulkupload_container">
      <PageTitle>{t("Bulk Upload Assets")}</PageTitle>
      <Tabs onChange={setCurrentTab} index={currentTab}>
        <TabList>
          <Tab>{t("Upload Files")}</Tab>
          {enable_external_assets && (
            <Tab>{t("Upload Externally Hosted Assets")}</Tab>
          )}
        </TabList>
        <FullWidthHorizontalSeparator />
        <TabPanels>
          <CustomTabPanel refreshKey={currentTab}>
            <UploadAssetsTab />
          </CustomTabPanel>
          {enable_external_assets && (
            <CustomTabPanel refreshKey={currentTab}>
              <AddExternalAssetFiles />
            </CustomTabPanel>
          )}
        </TabPanels>
      </Tabs>
    </PageWrapper>
  );
};
